import { IconInbox } from "@tabler/icons-react";
import { Card, Heading, Stack, Text, ThemeIcon } from "@/components/ui";

/**
 * Estado vacío genuino · la bandeja no tiene pendientes.
 */
export function BandejaVaciaCard() {
  return (
    <Card padding="xl">
      <Stack align="center" gap="md" className="py-8">
        <ThemeIcon variant="filled" color="multiva" size="xl">
          <IconInbox size={28} stroke={1.4} />
        </ThemeIcon>
        <Stack gap={4} align="center">
          <Heading order={4}>Bandeja vacía</Heading>
          <Text size="sm" c="dimmed" ta="center" className="max-w-100">
            No hay solicitudes pendientes para tu nivel y rol en este momento.
            La bandeja se actualiza cada 5 segundos.
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
}
